/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $MatchCount = {
    properties: {
        count: {
            type: 'number',
            isRequired: true,
        },
        regionId: {
            type: 'number',
            isRequired: true,
        },
    },
} as const;
